module.exports = __webpack_public_path__ + "static/media/up-arrow.348b0f29.svg";